import React from 'react';
import { Row, Col, Icon, Alert } from 'antd';

import Input from 'components/Fields/Input';
import { publicMessages } from 'components/FormMap/FormMap.config';
import { getAudience } from 'helpers/controlHelpers';

import styles from './controls.module.scss';

const Participants = ({ activity, activity: { participantCount, publicCount } }) => (
  <div>
    <h3>Nombre de personnes</h3>
    <Row gutter={24}>
      <Col span={24} lg={12}>
        <Input
          type="number"
          label="Organisateur(s) &amp; participant(s) / équipe technique"
          model=".participantCount"
          errorMessages={
            {
              required: {
                message: 'Le nombre d\'organisateur est obligatoire',
              },
              number: {
                message: 'Au moins une personne est obligatoire',
                rule: val => val && parseInt(val, 10) > 0,
              },
            }
          }
          defaultValue={participantCount || '1'}
          min={1}
        />
      </Col>
      <Col span={24} lg={12}>
        <Input
          type="number"
          label="Public &amp; audience / figurants et acteurs"
          model=".publicCount"
          errorMessages={
            {
              number: {
                message: 'Le nombre de public doit avoir une valeur numérique',
                rule: val => val && val.match(/^(\d)+?$/),
              },
            }
          }
          defaultValue={publicCount || '0'}
          min={0}
          max={1500}
        />
      </Col>
    </Row>
    {(Number(participantCount) + Number(publicCount) > 1500) && (
      <Row gutter={24}>
        <Col span={24}>
          <Alert
            className={styles.formActivity__alert}
            message={(
              <React.Fragment>
                <Icon type="warning" /> Compte tenu du nombre de participants, veuillez nous contacter par
                mail <a href={`mailto:autorisations.fontainebleau@onf.fr?subject=${encodeURIComponent("Déclaration d'activité : activité de plus de 1500 participants")}`}>autorisations.fontainebleau@onf.fr</a>.
              </React.Fragment>
            )}
            type="warning"
          />
        </Col>
      </Row>
    )}
    {getAudience(activity) >= 300 && (
      <Alert
        message="Remarque"
        description={publicMessages[1].text}
        type="warning"
        showIcon
        className={styles.formActivity__alert}
      />
    )}
  </div>
);

export default Participants;



// WEBPACK FOOTER //
// ./src/components/Form/FormActivity/Controls/ControlParticipants.js